import { EventDate, EventDateSectionSite, EventTicketSite } from '@/features/event/screens/Event';
import { onlyNumbers } from '@/helpers/common';
import { getBoolean, getItem, setItem } from '@/helpers/common/localStorage';
import { decrypt } from '@/helpers/crypt/crypt';
import { updateMaskCard, updateMaskCVV, validateCVV } from '@/helpers/masks/cardNumber';
import { unmask, updateMask as updateMaskCash } from '@/helpers/masks/cash';
import { updateMask as cepMask } from '@/helpers/masks/cep';
import { updateMask as updateMaskCPFOrCNPJ } from '@/helpers/masks/cpfCnpj';
import { updateMask } from '@/helpers/masks/expirationDate';
import validators from '@/helpers/validators';
import { useDialog } from '@/hooks/useDialog';
import CardClient from '@/model/CardClient';
import CardDb from '@/model/CardDb';
import CardFees from '@/model/CardFees';
import Cart from '@/model/Cart';
import CartEvent from '@/model/CartEvent';
import CartEventTicket from '@/model/CartEventTicket';
import CartPayment from '@/model/CartPayment';
import Client from '@/model/Client';
import OrderResponse from '@/model/OrderResponse';
import Payment from '@/model/Payment';
import PaymentType from '@/model/PaymentType';
import { setLoading } from '@/redux/loading/loadingSlice';
import { api, AxiosError } from '@/services/api';
import { REACT_APP_AUTH, REACT_CART } from '@/utils/config';
import React, { JSX, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import CartStorage from '@/features/core/cart/components/Cart';
import { Authenticate3DSError } from '@/model/Authenticate3DSError';
import { Authenticate3DSRequest } from '@/model/Authenticate3DSRequest';
import CartEventTicketUserData from '@/model/CartEventTicketUserData';
import { SessionResponse } from '@/model/SessionResponse';
import { ValidateCardcheckout } from '@/model/ValidateCardcheckout';
import MetaPixel from '@/utils/meta/metaPixel';
import { useLoginCaller } from '@/hooks/useLoginCaller';
import { setCardValidation } from '@/redux/cardValidation/cardValidationSlice';
import { CreditCardParameters } from '@/model/CreditCardParameters';
import { CheckCardWillValidateRequest } from '@/model/CheckCardWillValidateRequest';
import { CheckCardWillValidateResponse } from '@/model/CheckCardWillValidateResponse';
import { Loading3DSValidation } from '../../components/Loading3DSValidation';
import {
  Auth3DSResponse,
  Auth3DSStatus,
  CardCheckout,
  ShouldShowModalProps,
  ShowModalPayment,
} from '../../types';
import { CheckoutContainer } from './ui';

interface CustomError {
  message: string;
  details: string[];
}

interface StateProps {
  cameFromAdm: boolean;
}
interface DispatchProps {
  sendOrderToAPIEcommerce: (order: Cart) => Promise<OrderResponse>;
  sendOrderToAPIAdm: (payment: CartPayment) => Promise<OrderResponse>;
}

type Props = StateProps & DispatchProps;

export const CheckoutMain: React.FC<Props> = ({
  cameFromAdm,
  sendOrderToAPIEcommerce,
  sendOrderToAPIAdm,
}): JSX.Element => {
  const [cart, setCart] = useState<CartStorage>({
    events: [],
    discountCoupon: undefined,
    voucher: undefined,
    amountItens: 0,
    totalValue: 0,
    totalValueWithFee: 0,
    originalValueWithPaymentFee: 0,
    totalValueWithPaymentFee: 0,
    pdvId: undefined,
  });
  const [element, setElement] = useState<HTMLElement | null>();
  const [signed, setSigned] = useState<boolean>(getBoolean(String(REACT_APP_AUTH)));
  const [cards, setCards] = useState<CardClient[]>([]);
  const [payment, setPayment] = useState<Payment>(undefined as unknown as Payment);
  const [paymentType, setPaymentType] = useState<PaymentType>();
  const [cardCheckout, setCardCheckout] = useState<CardCheckout>();
  const [c6CreditCheckout, setC6CreditCheckout] = useState<boolean>(false);
  const [shouldShowModal, setShouldShowModal] = useState<ShowModalPayment>(
    ShowModalPayment.CREDIT_CARD_PAYMENT,
  );
  const [creditCardRemoveId, setCreditCardRemoveId] = useState<string>();
  const [orderResponse, setOrderResponse] = useState<OrderResponse>();
  const [messagePayment, setMessagePayment] = useState<string>();
  const [messageError, setMessageError] = useState<string>(
    'Houve um erro ao processar o seu pagamento. Verifique seus dados e tente novamente mais tarde.',
  );
  const [auth3DSResponse, setAuth3DSResponse] = useState<Auth3DSResponse>();
  const [auth3DSStatus, setAuth3DSStatus] = useState<Auth3DSStatus>(Auth3DSStatus.NONE);
  const [showLoadingPage3DSValidation, setShowLoadingPage3DSValidation] = useState<boolean>(false);

  const { setCaller } = useLoginCaller();
  const history = useNavigate();
  const dispatch = useDispatch();

  const { visible, onSetVisible, onToggle, title, onChangeTitle } = useDialog();

  const loadCart = (): void => {
    const cartStorage = getItem(REACT_CART as string) as string;
    let cartVariable: CartStorage | undefined;

    if (cartStorage && cartStorage.length > 0) {
      cartVariable = JSON.parse(cartStorage) as CartStorage;
      setCart(cartVariable);
    }
  };

  const checkPageLoaded = (): void => {
    const interval = setInterval(() => {
      const e = document.getElementById('btnDoLogin');
      if (e && interval) {
        setElement(e);
        setCaller('checkout');
        clearInterval(interval);
      }
    }, 100);
  };

  const getCart = (): CartStorage => {
    const cartStorage = getItem(REACT_CART as string) as string;
    let cartVariable: CartStorage | undefined;

    if (cartStorage && cartStorage.length > 0) {
      cartVariable = JSON.parse(cartStorage) as CartStorage;
    } else {
      cartVariable = {
        events: [],
        discountCoupon: undefined,
        voucher: undefined,
        amountItens: 0,
        totalValue: 0,
        totalValueWithFee: 0,
        originalValueWithPaymentFee: 0,
        totalValueWithPaymentFee: 0,
        pdvId: undefined,
      };
    }
    const newCart = cartVariable as CartStorage;

    return newCart;
  };

  const isAuth = async (): Promise<void> => {
    setTimeout(async () => {
      if (getBoolean(String(REACT_APP_AUTH)) !== signed) {
        setSigned(getBoolean(String(REACT_APP_AUTH)));
      } else {
        isAuth();
      }
    }, 500);
  };

  const getUserData = async (): Promise<void> => {
    const storageCart = getCart();
    if (storageCart && storageCart.events && storageCart.events.length > 0) {
      if (signed) {
        try {
          const { data } = await api.get<Client>('/client/my-account');
          setItem(REACT_CART as string, JSON.stringify(storageCart));
          setCart(storageCart);
          if (data.cards) {
            setCards(data.cards);
          }
        } catch {
          isAuth();
        }
      } else {
        if (element) {
          element.click();
        }
        isAuth();
      }
    } else {
      history('/');
    }
  };

  const checkPaymentOptions = (): void => {
    const tickets: EventTicketSite[] = [];
    const list: Payment[] = [];
    const listCardFees: CardFees[] = [];
    if (cart.events && cart.events.length > 0) {
      cart.events.forEach(event => {
        if (event.sections && event.sections.length > 0) {
          event.sections.forEach(section => {
            if (section.tickets && section.tickets.length > 0) {
              section.tickets.forEach(ticket => {
                tickets.push(ticket);
              });
            }
          });
        }
      });
    }

    if (tickets && tickets.length > 0) {
      tickets.forEach(ticket => {
        if (ticket.payment) {
          list.push(ticket.payment);
          if (ticket.payment.fees) {
            if (ticket.payment.fees) {
              listCardFees.push(ticket.payment.fees);
            }
          }
        }
      });
    }

    const installmentLimitList = list.sort((a, b) => {
      if (a.installmentLimit < b.installmentLimit) {
        return -1;
      }
      if (a.installmentLimit > b.installmentLimit) {
        return 1;
      }
      return 0;
    });
    const { installmentLimit } =
      installmentLimitList && installmentLimitList.length > 0
        ? installmentLimitList[0]
        : (undefined as unknown as Payment);

    let allowFractionalPayment = true;
    // eslint-disable-next-line no-plusplus
    for (let alp = 0; alp < list.length; alp++) {
      if (!list[alp].allowFractionalPayment) {
        allowFractionalPayment = false;
        break;
      }
    }

    let allowPaymentBankSlip = true;
    // eslint-disable-next-line no-plusplus
    for (let apbs = 0; apbs < list.length; apbs++) {
      if (!list[apbs].allowPaymentBankSlip) {
        allowPaymentBankSlip = false;
        break;
      }
    }

    let allowPaymentPIX = true;
    // eslint-disable-next-line no-plusplus
    for (let app = 0; app < list.length; app++) {
      if (!list[app].allowPaymentPIX) {
        allowPaymentPIX = false;
        break;
      }
    }

    let allowPaymentCredit = true;
    // eslint-disable-next-line no-plusplus
    for (let acp = 0; acp < list.length; acp++) {
      if (!list[acp].allowPaymentCredit) {
        allowPaymentCredit = false;
        break;
      }
    }

    let allowDiscount = false;
    // eslint-disable-next-line no-plusplus
    for (let ad = 0; ad < list.length; ad++) {
      if (list[ad].allowDiscount) {
        allowDiscount = true;
        break;
      }
    }

    const debitSorted = listCardFees.sort((a, b) => {
      if (a.debit > b.debit) {
        return -1;
      }
      if (a.debit < b.debit) {
        return 1;
      }
      return 0;
    });

    const creditSorted = listCardFees.sort((a, b) => {
      if (a.credit > b.credit) {
        return -1;
      }
      if (a.credit < b.credit) {
        return 1;
      }
      return 0;
    });

    const bankSlipSorted = listCardFees.sort((a, b) => {
      if (a.bankSlip > b.bankSlip) {
        return -1;
      }
      if (a.bankSlip < b.bankSlip) {
        return 1;
      }
      return 0;
    });

    const pixSorted = listCardFees.sort((a, b) => {
      if (a.pix > b.pix) {
        return -1;
      }
      if (a.pix < b.pix) {
        return 1;
      }
      return 0;
    });

    const installmentsSorted = listCardFees.sort((a, b) => {
      if (a.installments < b.installments) {
        return -1;
      }
      if (a.installments > b.installments) {
        return 1;
      }
      return 0;
    });

    const feeSorted = listCardFees.sort((a, b) => {
      if (a.fee > b.fee) {
        return -1;
      }
      if (a.fee < b.fee) {
        return 1;
      }
      return 0;
    });

    const fees: CardFees = {
      debit: debitSorted[0].debit,
      credit: creditSorted[0].credit,
      bankSlip: bankSlipSorted[0].bankSlip,
      pix: pixSorted[0].pix,
      installments: installmentsSorted[0].installments,
      fee: feeSorted[0].fee,
    };

    const dto: Payment = {
      installmentLimit,
      allowFractionalPayment,
      allowPaymentCredit,
      allowPaymentBankSlip,
      allowPaymentPIX,
      fees,
      allowDiscount,
    };
    setPayment(dto);
  };

  const toCurrency = (value: number): string => {
    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
    return formatter.format(value);
  };

  const addMask = (name: string, value: string): string => {
    let s = '';
    switch (name) {
      case 'number':
        s = updateMaskCard(value);
        break;
      case 'expDate':
        s = updateMask(value);
        break;
      case 'securityCode':
        s = updateMaskCVV(value);
        break;
      case 'document':
        s = updateMaskCPFOrCNPJ(value);
        break;
      case 'value':
        s = updateMaskCash(value);
        break;
      case 'zipCode':
        s = cepMask(value);
        break;
      case 'validationValue':
        s = updateMaskCash(value);
        break;
      default:
        s = value;
        break;
    }
    return s;
  };

  const handleChangeCreditCard = (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>,
  ): void => {
    let totalValue = 0;
    if (cardCheckout) {
      if (e.target.name === 'installments') {
        let value = cardCheckout.valueWithFee ? cardCheckout.valueWithFee : 0;
        const feeInstallment = payment.fees.fee / 100;
        const fee = payment.fees.credit / 100;
        value += value * fee;
        const installments = Number(e.target.value);
        if (installments === 1) {
          value += 0;
        } else {
          value *= (1 + feeInstallment) ** (installments - 1);
        }

        totalValue += value;
      }

      const newCardCheckout: CardCheckout = {
        ...cardCheckout,
        [e.target.name]: addMask(e.target.name, e.target.value),
      };
      if (totalValue > 0 && newCardCheckout.valueWithFee !== totalValue) {
        newCardCheckout.valueWithFee = totalValue;
      }
      if (e.target.name === 'value') {
        newCardCheckout.installments = 0;
        newCardCheckout.valueWithFee = Number(unmask(addMask('value', e.target.value)));
      }
      setCardCheckout(newCardCheckout);
    }

    if (e.target.name === 'installments') {
      const newCart = {
        ...cart,
        totalValueWithPaymentFee: totalValue,
      };
      setItem(REACT_CART as string, JSON.stringify(newCart));
      setCart(newCart);
    }
  };

  const handleSelectCard = async (id: string): Promise<void> => {
    try {
      dispatch(setLoading(true));
      const { data } = await api.get(`/client/my-account/card/${id}`);
      const cardDB = JSON.parse(decrypt(data.data)) as CardDb;
      if (cardCheckout) {
        const newCardCheckout: CardCheckout = {
          ...cardCheckout,
          id,
          number: cardDB.number,
          expDate: cardDB.expirationDate as string,
          securityCodeDb: cardDB.cvv,
          holder: cardDB.cardholderName,
          document: cardDB.cardholderCpf,
          validated: cardDB.validated,
        };
        setCardCheckout(newCardCheckout);
        dispatch(setLoading(false));
      }
    } catch {
      dispatch(setLoading(true));
    }
  };

  const handleOnShowModal = ({ value, newTitle }: ShouldShowModalProps): void => {
    setShouldShowModal(value);
    onChangeTitle(newTitle);
    onSetVisible(true);
  };

  const handleOnShowDeleteCreditCard = (id: string): void => {
    setCreditCardRemoveId(id);
    handleOnShowModal({
      value: ShowModalPayment.CONFIRM_DELETE_CREDIT_CARD_PAYMENT,
      newTitle: '',
    });
  };

  const handleOnDeleteCreditCard = async (): Promise<void> => {
    try {
      dispatch(setLoading(true));
      await api.delete<CardClient>(`/client/my-account/card/${creditCardRemoveId}`);
      await getUserData();
      onSetVisible(false);
      dispatch(setLoading(false));
      toast.success('Cartão removido com sucesso!');
    } catch {
      dispatch(setLoading(false));
    }
  };

  const handleOnCheckoutValidateCreditCard = async (): Promise<void> => {
    if (
      cardCheckout &&
      cardCheckout.validationValue &&
      cardCheckout.validationValue.trim().length > 0
    ) {
      const value = Number(unmask(cardCheckout.validationValue));
      if (value > 0) {
        dispatch(setLoading(true));
        try {
          const payload: ValidateCardcheckout = {
            cardId: cardCheckout.id,
            value,
          };
          await api.post('/client/my-account/card/validate/checkout', payload);
          toast.success('Cartão validado com sucesso!');
          getUserData();
        } catch (error) {
          const messagesValidationError: string[] = [];
          if (error instanceof AxiosError) {
            const axiosError = error as AxiosError<CustomError, CustomError>;
            if (axiosError.response && axiosError.response.data) {
              if (axiosError.response.data.details && axiosError.response.data.details.length > 0) {
                axiosError.response.data.details.forEach(data => {
                  messagesValidationError.push(data);
                });
              } else if (axiosError.response.data.message) {
                messagesValidationError.push(axiosError.response.data.message);
              } else {
                messagesValidationError.push('Houve um erro ao processar o seu cartão');
              }
            } else {
              messagesValidationError.push('Houve um erro ao processar o seu cartão');
            }
          } else {
            messagesValidationError.push('Houve um erro ao processar o seu cartão');
          }
          messagesValidationError.forEach(data => {
            toast.warning(data);
          });
        } finally {
          dispatch(setLoading(false));
        }
      } else {
        cardCheckout.validationValueError = 'Campo Obrigatório';
        setCardCheckout(cardCheckout);
      }
    }
  };

  const handleOnAddCard = (): void => {
    const events: string[] = [];
    if (cart && cart.events && cart.events.length > 0) {
      cart.events.forEach(data => {
        events.push(data.id);
      });
    }
    const payload: CreditCardParameters = {
      openOnProfile: false,
      events,
    };
    dispatch(setCardValidation(payload));
    history('/create-card');
  };

  const handleOnIncrementTicket = (item: EventTicketSite): void => {
    const newCart = getCart();
    newCart.events.forEach(event => {
      event.sections.forEach(section => {
        section.tickets.forEach(ticket => {
          if (ticket.id === item.id && ticket.isHalfPrice === item.isHalfPrice) {
            ticket.userDatas.push({} as CartEventTicketUserData);
            // eslint-disable-next-line no-param-reassign
            ticket.quantity += 1;
            newCart.amountItens += 1;
            newCart.totalValue = Number(newCart.totalValue) + Number(ticket.unitValue);
            const newTotalValueWithFee =
              Number(newCart.totalValueWithFee) + Number(ticket.unitValue) * Number(ticket.fee);
            newCart.totalValueWithFee = Number(newTotalValueWithFee.toFixed(2));
            const newTotalValueWithPaymentFee =
              Number(newCart.totalValueWithPaymentFee) +
              Number(ticket.unitValue) * Number(ticket.fee);
            newCart.totalValueWithPaymentFee = Number(newTotalValueWithPaymentFee.toFixed(2));
            const newOriginalValueWithPaymentFee =
              Number(newCart.originalValueWithPaymentFee) +
              Number(ticket.unitValue) * Number(ticket.fee);
            newCart.originalValueWithPaymentFee = Number(newOriginalValueWithPaymentFee.toFixed(2));
          }
        });
      });
    });
    setItem(REACT_CART as string, JSON.stringify(newCart));
    setCart(newCart);
  };

  const handleOnRemoveCupom = (): void => {
    const newCart = getCart();
    if (cart.discountCoupon) {
      newCart.totalValueWithPaymentFee = newCart.totalValueWithFee;
    } else if (cart.voucher) {
      newCart.totalValueWithPaymentFee = newCart.totalValueWithFee;
    }
    newCart.discountCoupon = undefined;
    newCart.voucher = undefined;
    setItem(REACT_CART as string, JSON.stringify(newCart));
    setCart(newCart);
  };

  const handleOnClear = (): void => {
    const newCart = {
      events: [],
      discountCoupon: undefined,
      voucher: undefined,
      amountItens: 0,
      totalValue: 0,
      totalValueWithFee: 0,
      originalValueWithPaymentFee: 0,
      totalValueWithPaymentFee: 0,
    };
    setItem(REACT_CART as string, JSON.stringify(newCart));
    setCart(newCart);
    history('/');
  };

  const handleOnDecrementTicket = (item: EventTicketSite): void => {
    const newCart = getCart();
    let countTicketDiscount = 0;

    let spliceEvent = false;
    let countEvent = 0;
    let indexEvent = 0;
    newCart.events.forEach(data => {
      let spliceSection = false;
      let countSection = 0;
      let indexSection = 0;
      data.sections.forEach(section => {
        let spliceTicket = false;
        let countTicket = 0;
        let indexTicket = 0;
        section.tickets.forEach(ticket => {
          if (
            newCart.checkDiscount &&
            newCart.checkDiscount.tickets &&
            newCart.checkDiscount.tickets.length > 0 &&
            newCart.discountCoupon
          ) {
            // eslint-disable-next-line no-plusplus
            for (let td = 0; td < newCart.checkDiscount.tickets.length; td++) {
              if (
                newCart.checkDiscount.tickets[td].discountCoupon &&
                newCart.checkDiscount.tickets[td].discountCoupon?.id === newCart.discountCoupon.id
              ) {
                if (ticket.id === newCart.checkDiscount.tickets[td].id) {
                  countTicketDiscount = ticket.quantity - 1;
                  break;
                }
              }
            }
          }
          if (ticket.id === item.id && ticket.unitValue === item.unitValue) {
            ticket.userDatas.splice(ticket.userDatas.length - 1, 1);
            // eslint-disable-next-line no-param-reassign
            ticket.quantity -= 1;
            if (ticket.quantity === 0) {
              spliceTicket = true;
              indexTicket = countTicket + 0;
            }
            newCart.amountItens -= 1;
            newCart.totalValue = Number(newCart.totalValue) - Number(item.unitValue);
            newCart.totalValueWithFee =
              Number(newCart.totalValueWithFee) - Number(ticket.unitValue) * Number(ticket.fee);
            newCart.totalValueWithPaymentFee =
              Number(newCart.totalValueWithPaymentFee) -
              Number(ticket.unitValue) * Number(ticket.fee);
            newCart.originalValueWithPaymentFee =
              Number(newCart.originalValueWithPaymentFee) -
              Number(ticket.unitValue) * Number(ticket.fee);
          }
          // eslint-disable-next-line no-plusplus
          countTicket++;
        });
        if (spliceTicket) {
          section.tickets.splice(indexTicket, 1);
        }
        if (section.tickets.length === 0) {
          spliceSection = true;
          indexSection = countSection + 0;
        }
        // eslint-disable-next-line no-plusplus
        countSection++;
      });
      if (spliceSection) {
        data.sections.splice(indexSection, 1);
      }

      if (data.sections.length === 0) {
        spliceEvent = true;
        indexEvent = countEvent + 0;
      }
      // eslint-disable-next-line no-plusplus
      countEvent++;
    });

    if (spliceEvent) {
      newCart.events.splice(indexEvent, 1);
    }

    if (newCart.amountItens > 0) {
      // dispatch(setCart(newCart));
      setItem(REACT_CART as string, JSON.stringify(newCart));
      setCart(newCart);
      if (
        countTicketDiscount === 0 &&
        newCart.checkDiscount &&
        newCart.checkDiscount.tickets &&
        newCart.checkDiscount.tickets.length > 0 &&
        newCart.discountCoupon
      ) {
        newCart.checkDiscount = undefined;
        newCart.discountCoupon = undefined;
        handleOnRemoveCupom();
      }
    } else {
      handleOnClear();
    }
  };

  const handleSetPaymentType = (type: PaymentType): void => {
    setCardCheckout(undefined);
    if (type !== undefined && type !== null) {
      let fee = 0;
      const valueBase = cart.originalValueWithPaymentFee;
      if (type === PaymentType.CREDIT_CARD) {
        let isC6 = false;
        if (cart.events && cart.events.length > 0) {
          // eslint-disable-next-line no-plusplus
          for (let e = 0; e < cart.events.length; e++) {
            if (cart.events[e].sections && cart.events[e].sections.length > 0) {
              // eslint-disable-next-line no-plusplus
              for (let s = 0; s < cart.events[e].sections.length; s++) {
                if (
                  cart.events[e].sections[s].tickets &&
                  cart.events[e].sections[s].tickets.length > 0
                ) {
                  // eslint-disable-next-line no-plusplus
                  for (let t = 0; t < cart.events[e].sections[s].tickets.length; t++) {
                    if (
                      cart.events[e].sections[s].tickets[t].gatewayCredit &&
                      cart.events[e].sections[s].tickets[t].gatewayCredit === 'C6'
                    ) {
                      isC6 = true;
                      break;
                    }
                  }
                }
              }
            }
          }
        }
        if (isC6) {
          setC6CreditCheckout(true);
        } else if (!cards || (cards && cards.length <= 0)) {
          handleOnShowModal({
            value: ShowModalPayment.NO_CARD,
            newTitle: '',
          });
        }

        setCardCheckout({
          value: toCurrency(valueBase),
          valueWithFee: valueBase,
          installments: 0,
          cardSelectedInt: 50,
        } as CardCheckout);
      } else if (type === PaymentType.BANK_SLIP) {
        fee = payment.fees.bankSlip;
      } else if (type === PaymentType.PIX) {
        fee = payment.fees.pix;
      }
      fee = fee / 100 + 1;
      const totalValueWithPaymentFee = valueBase * fee;

      const newEventDates: EventDate[] = [];
      const newSections: EventDateSectionSite[] = [];
      cart.events.forEach(event => {
        if (event.sections && event.sections.length > 0) {
          event.sections.forEach(section => {
            const newTickets: EventTicketSite[] = [];
            if (section.tickets && section.tickets.length > 0) {
              section.tickets.forEach(ticket => {
                const newTicket = {
                  ...ticket,
                  fee,
                  totalValue: Number(ticket.unitValue) * fee,
                };
                newTickets.push(newTicket);
              });
            }
            const newSection = {
              ...section,
              tickets: newTickets,
            };
            newSections.push(newSection);
          });
        }
        const newEvent = {
          ...event,
          sections: newSections,
        };
        newEventDates.push(newEvent);
      });

      const newCart = {
        ...cart,
        totalValueWithPaymentFee,
      };
      setItem(REACT_CART as string, JSON.stringify(newCart));
      setCart(newCart);
    }

    setPaymentType(type);
  };

  const isCardCheckoutValid = (): boolean => {
    const newCardCheckout = { ...cardCheckout } as CardCheckout;
    let b = true;
    let validate: string | boolean;
    validate = newCardCheckout.number
      ? validators.cardNumber(newCardCheckout.number)
      : 'Numero do Cartão obrigatorio';
    newCardCheckout.numberError = validate || (undefined as unknown as string);

    validate = newCardCheckout.expDate
      ? validators.cardExpirationDate(newCardCheckout.expDate)
      : 'Vencimento do Cartão obrigatório';
    newCardCheckout.expDateError = validate || (undefined as unknown as string);

    validate = newCardCheckout.securityCode
      ? validateCVV(onlyNumbers(`${newCardCheckout.number}`), newCardCheckout.securityCode)
      : 'CVV obrigatório';
    // eslint-disable-next-line no-nested-ternary
    newCardCheckout.securityCodeError = !validate
      ? 'CVV verificador inválido.'
      : validate === 'Campo obrigatório'
        ? validate
        : (undefined as unknown as string);

    if (newCardCheckout.securityCodeDb !== newCardCheckout.securityCode) {
      newCardCheckout.securityCodeError = 'CVV não confere.';
    }

    validate = newCardCheckout.holder ? false : 'Nome no cartão obrigatório';
    newCardCheckout.holderError = validate || (undefined as unknown as string);

    validate = newCardCheckout.document
      ? validators.cpforcnpj(newCardCheckout.document)
      : 'CPF do utilizador obrigatório';
    newCardCheckout.documentError = validate || (undefined as unknown as string);

    if (cardCheckout) {
      if (!newCardCheckout.value) {
        newCardCheckout.valueError = 'Campo obrigatório';
      } else {
        const unMasked = Number(unmask(newCardCheckout.value));
        if (unMasked === 0) {
          newCardCheckout.valueError = 'Valor deverá ser maior que zero';
        } else if (unMasked > cart.totalValueWithFee) {
          newCardCheckout.valueError = 'Valor informado maior que o valor total dos itens';
        } else {
          newCardCheckout.valueError = undefined as unknown as string;
        }
      }
    }

    if (!newCardCheckout.valueError && cardCheckout) {
      let cardValues = 0;
      const unMasked = cardCheckout.value ? Number(unmask(cardCheckout.value)) : 0;
      cardValues += unMasked;

      const totalValueWithFee = toCurrency(cart.totalValueWithFee);

      const abc = toCurrency(cardValues).replace(/\u00A0/g, ' ');

      const normalizeMoneyText = (v: string): string => {
        const normalized = v
          .replace(/\u00A0/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
        return normalized;
      };

      const abcNormalize = normalizeMoneyText(abc);
      const totalValueWithFeeNormalize = normalizeMoneyText(totalValueWithFee);

      if (abcNormalize !== totalValueWithFeeNormalize) {
        newCardCheckout.valueError = 'Valor total divergente do valor dos cartões';
      }
    }

    newCardCheckout.installmentsError =
      !newCardCheckout.installments || newCardCheckout.installments === 0
        ? 'Campo obrigatório'
        : (undefined as unknown as string);
    if (
      newCardCheckout.numberError ||
      newCardCheckout.expDateError ||
      newCardCheckout.securityCodeError ||
      newCardCheckout.holderError ||
      newCardCheckout.documentError ||
      newCardCheckout.valueError ||
      newCardCheckout.installmentsError
    ) {
      b = false;
    }
    if (!b) {
      setCardCheckout(newCardCheckout);
    }

    return b;
  };

  const metaPixel = (
    idPixel: string,
    orderId: string,
    totalValue: number,
    currency: string,
  ): void => {
    const dynamicMetaPixel = MetaPixel(idPixel);
    dynamicMetaPixel.trackPageView();
    dynamicMetaPixel.purchase(orderId, totalValue, currency);
  };

  const connectToWebSocket = (orderId: string): void => {
    const socket = new WebSocket(
      `wss://api.bancadoingresso.com.br/api/websocket/v1/pix/${orderId}`,
    );
    socket.onopen = (): void => {
      // eslint-disable-next-line no-console
      console.log('Connected to the web socket');
    };
    socket.onmessage = (m: MessageEvent<string>) => {
      if (m.data === 'APPROVED') {
        handleOnShowModal({
          value: ShowModalPayment.CREDIT_CARD_PAYMENT,
          newTitle: '',
        });
      }
    };
    socket.onclose = () => {
      connectToWebSocket(orderId);
    };
    socket.onerror = () => {
      connectToWebSocket(orderId);
    };
  };

  const checkPaymentCreditCard = async (): Promise<boolean | string[]> => {
    let b = true;
    let errorMessages: string[] | undefined;
    if (paymentType === PaymentType.CREDIT_CARD) {
      if (c6CreditCheckout) {
        const newCardCheckout = { ...cardCheckout } as CardCheckout;
        if (cardCheckout) {
          if (!newCardCheckout.value) {
            newCardCheckout.valueError = 'Campo obrigatório';
          } else {
            const unMasked = Number(unmask(newCardCheckout.value));
            if (unMasked === 0) {
              newCardCheckout.valueError = 'Valor deverá ser maior que zero';
            } else if (unMasked > cart.totalValueWithFee) {
              newCardCheckout.valueError = 'Valor informado maior que o valor total dos itens';
            } else {
              newCardCheckout.valueError = undefined as unknown as string;
            }
          }
        }

        if (!newCardCheckout.valueError && cardCheckout) {
          let cardValues = 0;
          const unMasked = cardCheckout.value ? Number(unmask(cardCheckout.value)) : 0;
          cardValues += unMasked;

          const totalValueWithFee = toCurrency(cart.totalValueWithFee);

          const abc = toCurrency(cardValues).replace(/\u00A0/g, ' ');

          const normalizeMoneyText = (v: string): string => {
            const normalized = v
              .replace(/\u00A0/g, ' ')
              .replace(/\s+/g, ' ')
              .trim();
            return normalized;
          };

          const abcNormalize = normalizeMoneyText(abc);
          const totalValueWithFeeNormalize = normalizeMoneyText(totalValueWithFee);

          if (abcNormalize !== totalValueWithFeeNormalize) {
            newCardCheckout.valueError = 'Valor total divergente do valor dos cartões';
          }
        }

        newCardCheckout.installmentsError =
          !newCardCheckout.installments || newCardCheckout.installments === 0
            ? 'Campo obrigatório'
            : (undefined as unknown as string);
        if (
          newCardCheckout.numberError ||
          newCardCheckout.expDateError ||
          newCardCheckout.securityCodeError ||
          newCardCheckout.holderError ||
          newCardCheckout.documentError ||
          newCardCheckout.valueError ||
          newCardCheckout.installmentsError
        ) {
          b = false;
        }
        if (!b) {
          setCardCheckout(newCardCheckout);
        }
      } else {
        const events: string[] = [];
        if (cart && cart.events && cart.events.length > 0) {
          cart.events.forEach(data => {
            events.push(data.id);
          });
        }
        const payload: CheckCardWillValidateRequest = {
          events,
        };
        if (cardCheckout) {
          if (isCardCheckoutValid()) {
            if (!cardCheckout.validated) {
              const checkCardWillValidateResponse = await api.post<CheckCardWillValidateResponse>(
                '/client/my-account/card/check-validate',
                payload,
              );
              if (
                checkCardWillValidateResponse &&
                checkCardWillValidateResponse.data &&
                checkCardWillValidateResponse.data.validate
              ) {
                history(`/validated-card/${cardCheckout.id}`);
                return false;
              }
              b = true;
            } else {
              b = true;
            }
          }
        }
      }
    }
    if (errorMessages) {
      return errorMessages;
    }
    return b;
  };

  const create3DSAuthRequest = async (selectedPayment: CartPayment): Promise<void> => {
    try {
      setAuth3DSResponse(undefined);
      if (cardCheckout) {
        const { data } = await api.post<SessionResponse>('/event/session', selectedPayment);
        const decrypted = decrypt(data.requests);
        const request = JSON.parse(decrypted) as Authenticate3DSRequest;

        if (request && cardCheckout) {
          const newAuth3DSResponse: Auth3DSResponse = {
            cardId: selectedPayment.clientCardId as string,
            session: data.session,
            installments: selectedPayment.installments,
            paymentOriginalValue: selectedPayment.paymentOriginalValue,
            paymentValue: selectedPayment.paymentValue,
            paymentFee: selectedPayment.paymentFee,
            request,
          };
          setAuth3DSResponse(newAuth3DSResponse);
          setAuth3DSStatus(Auth3DSStatus.START);
        }
      }
    } catch {
      dispatch(setLoading(false));
    }
  };

  const createOrderObject = async (selectedPayment: CartPayment): Promise<void> => {
    const order: Cart = {
      events: [],
      amountItens: cart.amountItens,
      totalValue: cart.totalValue,
      totalValueWithFee: cart.totalValueWithFee,
      totalValueWithPaymentFee: Number(cart.totalValueWithPaymentFee.toFixed(2)),
      discountCoupon:
        cart.discountCoupon && cart.discountCoupon.id ? cart.discountCoupon : undefined,
      voucher: cart.voucher && cart.voucher.id ? cart.voucher : undefined,
      payment: selectedPayment,
      pdvId: cart.pdvId,
    };

    const paymentValueFee = order.totalValueWithPaymentFee - order.totalValueWithFee;
    const paymentFee = (paymentValueFee * 100) / order.totalValue / 100 + 1;

    cart.events.forEach(event => {
      const cartEventTickets: CartEventTicket[] = [];
      if (event.sections && event.sections.length > 0) {
        event.sections.forEach(section => {
          if (section.tickets && section.tickets.length > 0) {
            section.tickets.forEach(ticket => {
              const cartEventTicket: CartEventTicket = {
                id: ticket.id,
                unitValue: ticket.unitValue,
                batchId: ticket.batchId,
                fee: ticket.fee,
                paymentFee,
                totalValue: ticket.totalValue,
                isHalfPrice: ticket.isHalfPrice,
                lables: ticket.labels && ticket.labels.length > 0 ? ticket.labels : undefined,
                quantity: ticket.quantity,
                userDatas: ticket.userDatas,
              };
              cartEventTickets.push(cartEventTicket);
            });
          }
        });
      }
      const cartEvent: CartEvent = {
        eventId: event.id,
        tickets: cartEventTickets && cartEventTickets.length > 0 ? cartEventTickets : undefined,
      };

      order.events.push(cartEvent);
    });
    try {
      let response: OrderResponse | undefined;
      if (cameFromAdm) {
        response = await sendOrderToAPIAdm(order.payment);
      } else {
        response = await sendOrderToAPIEcommerce(order);
      }
      if (response && response.paymentMessage) {
        setMessagePayment(response.paymentMessage);
        handleOnShowModal({
          value: ShowModalPayment.PAYMENT_NOTMADE,
          newTitle: '',
        });
        return;
      }

      setOrderResponse(response);

      if (cart.events && cart.events.length > 0) {
        // Pixel
        // eslint-disable-next-line no-plusplus
        for (let e = 0; e < cart.events.length; e++) {
          if (
            cart.events[e].pixel &&
            cart.events[e].pixel !== undefined &&
            cart.events[e].pixel !== null
          ) {
            const pixel = cart.events[e].pixel as string;

            if (pixel !== null && pixel !== undefined && pixel.trim().length > 0) {
              metaPixel(pixel, cart.events[e].id, cart.totalValueWithPaymentFee, 'BRL');
            }
          }
        }
      }
      if (paymentType === PaymentType.CREDIT_CARD) {
        if (response.fileURL) {
          const nextURL = response.fileURL;
          window.location.href = nextURL;
          window.location.assign(nextURL);
          window.location.replace(nextURL);
          const newCart = {
            events: [],
            discountCoupon: undefined,
            voucher: undefined,
            amountItens: 0,
            totalValue: 0,
            totalValueWithFee: 0,
            originalValueWithPaymentFee: 0,
            totalValueWithPaymentFee: 0,
          };
          setItem(REACT_CART as string, JSON.stringify(newCart));
          setCart(newCart);
        } else {
          handleOnShowModal({
            value: ShowModalPayment.CREDIT_CARD_PAYMENT,
            newTitle: '',
          });
        }
      } else if (paymentType === PaymentType.PIX) {
        handleOnShowModal({
          value: ShowModalPayment.PIX_PAYMENT,
          newTitle: '',
        });
        connectToWebSocket(response.orderId);
      } else {
        handleOnShowModal({
          value: ShowModalPayment.TICKET_PAYMENT,
          newTitle: '',
        });
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        const axiosError = error as AxiosError<CustomError, CustomError>;
        if (axiosError.response && axiosError.response.data) {
          if (axiosError.response.data.details && axiosError.response.data.details.length > 0) {
            setMessageError(axiosError.response.data.details[0]);
          } else if (axiosError.response.data.message) {
            setMessageError(axiosError.response.data.message);
          } else {
            setMessageError(
              'Houve um erro ao processar o seu pagamento. Verifique seus dados e tente novamente mais tarde.',
            );
          }
        }
      }
      handleOnShowModal({
        value: ShowModalPayment.PAYMENT_ERROR,
        newTitle: '',
      });
    } finally {
      dispatch(setLoading(false));
      setAuth3DSResponse(undefined);
      setAuth3DSStatus(Auth3DSStatus.NONE);
    }
  };

  const handleSendOrder = async (): Promise<void> => {
    if (paymentType === undefined) {
      toast.warn('Selecione a forma de pagamento!');
    } else {
      dispatch(setLoading(true));
      if (paymentType === PaymentType.CREDIT_CARD) {
        if (cardCheckout) {
          const checkPayment = await checkPaymentCreditCard();
          if (!(checkPayment instanceof Array) && checkPayment) {
            const paymentOriginalValue = Number(Number(unmask(cardCheckout.value)).toFixed(2));
            const paymentValue = Number(Number(cart.totalValueWithPaymentFee).toFixed(2));
            const priceDiff = paymentValue - paymentOriginalValue;
            const paymentFee =
              priceDiff > 0 ? (priceDiff * 100) / paymentOriginalValue / 100 + 1 : 0;
            const newPayment: CartPayment = {
              clientCardId: c6CreditCheckout ? undefined : cardCheckout.id,
              paymentType: PaymentType.CREDIT_CARD,
              installments: Number(cardCheckout.installments),
              paymentOriginalValue,
              paymentValue,
              paymentFee,
            };
            if (c6CreditCheckout) {
              createOrderObject(newPayment);
            } else {
              if (isCardCheckoutValid()) {
                create3DSAuthRequest(newPayment);
                return;
              }
              dispatch(setLoading(false));
              toast.warn('Selecione um cartão');
            }
          } else {
            dispatch(setLoading(false));
            if (checkPayment instanceof Array) {
              setMessageError(checkPayment[0]);
              handleOnShowModal({
                value: ShowModalPayment.PAYMENT_ERROR,
                newTitle: '',
              });
            }
          }
        }
      } else if (paymentType === PaymentType.BANK_SLIP || paymentType === PaymentType.PIX) {
        const paymentOriginalValue = cart.totalValueWithPaymentFee;
        const newPayment: CartPayment = {
          paymentType,
          installments: 1,
          paymentOriginalValue,
          paymentValue: cart.totalValueWithPaymentFee,
          paymentFee: 0,
        };
        createOrderObject(newPayment);
      }
    }
  };

  const handleOnGoToTickets = (): void => {
    const newCart = {
      events: [],
      discountCoupon: undefined,
      voucher: undefined,
      amountItens: 0,
      totalValue: 0,
      totalValueWithFee: 0,
      originalValueWithPaymentFee: 0,
      totalValueWithPaymentFee: 0,
    };
    setItem(REACT_CART as string, JSON.stringify(newCart));
    setCart(newCart);
    history('/ingressos');
  };

  const handleOnCopyText = (text: string): void => {
    navigator.clipboard.writeText(text);
    toast.info('Conteudo copiado com sucesso!');
  };

  /*
  const handleToogleModal = (): void => {
    onToggle();
    if (paymentType === PaymentType.BANK_SLIP || paymentType === PaymentType.PIX) {
      handleGoToTickets();
    }
  };
  */

  const handleSendOrderCreditCard = async (): Promise<void> => {
    dispatch(setLoading(true));
    if (auth3DSResponse && cardCheckout) {
      const { REACT_APP_PAGSEGURO_TOKEN } = process.env;
      const split = cardCheckout.expDate.split('/');
      const card = PagSeguro.encryptCard({
        publicKey: REACT_APP_PAGSEGURO_TOKEN,
        holder: cardCheckout.holder,
        number: cardCheckout.number,
        expMonth: split[0],
        expYear: split[1],
        securityCode: cardCheckout.securityCodeDb,
      });
      const encrypted = card.encryptedCard;
      const newPayment: CartPayment = {
        paymentType: PaymentType.CREDIT_CARD,
        installments: Number(auth3DSResponse.installments),
        clientCardId: auth3DSResponse.cardId,
        encrypted,
        authenticationId:
          auth3DSResponse.response &&
          auth3DSResponse.response.status === 'AUTH_FLOW_COMPLETED' &&
          auth3DSResponse.response.authenticationStatus === 'AUTHENTICATED'
            ? auth3DSResponse.response?.id
            : undefined,
        paymentOriginalValue: auth3DSResponse.paymentOriginalValue,
        paymentValue: auth3DSResponse.paymentValue,
        paymentFee: auth3DSResponse.paymentFee,
      };
      await createOrderObject(newPayment);
    }
  };

  const create3DSAuth = async (selectedAuth3DSResponse: Auth3DSResponse): Promise<void> => {
    const { REACT_APP_PAGSEGURO_ENV } = process.env;
    PagSeguro.setUp({
      session: selectedAuth3DSResponse.session,
      env: REACT_APP_PAGSEGURO_ENV as 'PROD' | 'SANDBOX',
    });
    try {
      dispatch(setLoading(false));
      setShowLoadingPage3DSValidation(true);
      const response = await PagSeguro.authenticate3DS(selectedAuth3DSResponse.request);
      const newAuth3DSResponse = {
        ...selectedAuth3DSResponse,
        response,
      };
      setAuth3DSResponse(newAuth3DSResponse);
      setAuth3DSStatus(Auth3DSStatus.AUTH_SUCCESS);
    } catch (error) {
      const newError = error as Authenticate3DSError;
      const newAuth3DSResponse = {
        ...selectedAuth3DSResponse,
        error: newError,
      };

      setAuth3DSResponse(newAuth3DSResponse);
      setAuth3DSStatus(Auth3DSStatus.AUTH_ERROR);
    }
  };

  const checkAuth3DS = (): void => {
    let message: string | undefined;
    if (auth3DSResponse && auth3DSResponse.response && auth3DSResponse.response.status) {
      if (auth3DSResponse.response.status === 'AUTH_FLOW_COMPLETED') {
        if (auth3DSResponse.response.authenticationStatus === 'AUTHENTICATED') {
          setShowLoadingPage3DSValidation(false);
          handleSendOrderCreditCard();
        } else {
          message = 'Valicação 3DS não autenticada!';
        }
      } else if (auth3DSResponse.response.status === 'AUTH_NOT_SUPPORTED') {
        setShowLoadingPage3DSValidation(false);
        handleSendOrderCreditCard();
      } else if (auth3DSResponse.response.status === 'CHANGE_PAYMENT_METHOD') {
        message = 'Validação 3DS solicitou alterar a forma de pagamento!';
      } else if (auth3DSResponse.response.status === 'REQUIRE_CHALLENGE') {
        message = 'O emissor do cartão solicita que o desafio seja realizado!';
      }
    }
    if (message) {
      setShowLoadingPage3DSValidation(false);
      setMessageError(message);
      handleOnShowModal({
        value: ShowModalPayment.PAYMENT_ERROR,
        newTitle: '',
      });
    } else if (auth3DSResponse && !auth3DSResponse.response) {
      create3DSAuth(auth3DSResponse);
    }
  };

  useEffect(() => {
    if (auth3DSStatus === Auth3DSStatus.START && auth3DSResponse) {
      create3DSAuth(auth3DSResponse);
    } else if (auth3DSStatus === Auth3DSStatus.AUTH_SUCCESS && auth3DSResponse) {
      let check = false;

      if (auth3DSResponse.response) {
        check = true;
      }

      if (check) {
        setTimeout(() => {
          checkAuth3DS();
        }, 300);
      }
    } else if (auth3DSStatus === Auth3DSStatus.AUTH_ERROR) {
      let message = 'Erro ao criar sessão 3DS!';
      if (
        auth3DSResponse &&
        auth3DSResponse.error &&
        auth3DSResponse.error.detail &&
        auth3DSResponse.error.detail.errorMessages &&
        auth3DSResponse.error.detail.errorMessages.length > 0
      ) {
        message = `Erro ao criar sessão 3DS, Código: ${auth3DSResponse.error.detail.errorMessages[0].code} - Descrição: ${auth3DSResponse.error.detail.errorMessages[0].description}`;
      }
      setShowLoadingPage3DSValidation(false);
      setMessageError(message);
      handleOnShowModal({
        value: ShowModalPayment.PAYMENT_ERROR,
        newTitle: '',
      });
    }
  }, [auth3DSStatus, auth3DSResponse]);

  useEffect(() => {
    if (signed) {
      getUserData();
    }
  }, [signed]);

  useEffect(() => {
    if (cart && cart.events && cart.events.length > 0) {
      checkPaymentOptions();
    }
  }, [cart]);

  useEffect(() => {
    if (element) {
      getUserData();
    }
  }, [element]);

  useEffect(() => {
    loadCart();
    checkPageLoaded();
  }, []);

  return (
    <>
      {showLoadingPage3DSValidation ? (
        <Loading3DSValidation />
      ) : (
        <>
          {cart && cart.events.length > 0 && (
            <CheckoutContainer
              cart={cart}
              toCurrency={toCurrency}
              payment={payment}
              paymentType={paymentType}
              card={cardCheckout}
              c6CreditCheckout={c6CreditCheckout}
              onChangeCreditCard={handleChangeCreditCard}
              cards={cards}
              onCardSelected={handleSelectCard}
              onShowDeleteCreditCard={handleOnShowDeleteCreditCard}
              onDeleteCreditCard={handleOnDeleteCreditCard}
              checkoutValidateCreditCard={handleOnCheckoutValidateCreditCard}
              onAddCard={handleOnAddCard}
              cameFromAdm={cameFromAdm}
              onIncrementTicket={handleOnIncrementTicket}
              onDecrementTicket={handleOnDecrementTicket}
              onRemoveCupom={handleOnRemoveCupom}
              onSetPaymentType={handleSetPaymentType}
              onSendOrder={handleSendOrder}
              visible={visible}
              title={title}
              onToggle={onToggle}
              shouldShowModal={shouldShowModal}
              onGoToTickets={handleOnGoToTickets}
              boleto={orderResponse && orderResponse.fileURL ? orderResponse.fileURL : ''}
              barcode={orderResponse && orderResponse.content ? orderResponse.content : ''}
              onCopyText={handleOnCopyText}
              qrCodeImage={orderResponse && orderResponse.fileURL ? orderResponse.fileURL : ''}
              qrCodeText={orderResponse && orderResponse.content ? orderResponse.content : ''}
              messageError={messageError}
              messagePayment={messagePayment}
            />
          )}
        </>
      )}
    </>
  );
};

export const CheckoutScreen: React.FC = (): JSX.Element => {
  const handleOnSendOrderToAPIEcommerce = async (order: Cart): Promise<OrderResponse> => {
    const { data } = await api.post<OrderResponse>('/event/order', order);
    return data;
  };
  const handleOnSendOrderToAPIAdm = async (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    payment: CartPayment,
  ): Promise<OrderResponse> => {
    throw new AxiosError('Not Implemented!');
  };
  return (
    <CheckoutMain
      cameFromAdm={false}
      sendOrderToAPIEcommerce={handleOnSendOrderToAPIEcommerce}
      sendOrderToAPIAdm={handleOnSendOrderToAPIAdm}
    />
  );
};
